import React, { useEffect } from "react";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import LoginCoordinator from "./Login";
import { makeUrl } from "../../../api/makeUrl";

const LoginCoordinatorContainer: React.FC = () => {
    const { state, dispatch, getClientVerificationToken, finishLogin, setActiveView } = useAuthenticationStore();
    const { signInId, email, serverError, isLoading } = state;

    useEffect(() => {
        if (!signInId) {
            window.location.href = makeUrl("~/");
        }
    }, [signInId]);

    const setEmail = (newEmail: string) => {
        dispatch({ type: "SET_EMAIL", payload: newEmail });
    };

    const forgotPassword = () => {
        setActiveView(AuthenticationViews.forgotPassword);
    };

    return (
        <LoginCoordinator
            email={email}
            finishLogin={finishLogin}
            forgotPassword={forgotPassword}
            isLoading={isLoading}
            joinLink={"../" + AuthenticationViews.join}
            serverError={serverError}
            setEmail={setEmail}
            getClientVerificationToken={getClientVerificationToken}
        />
    );
};

export default LoginCoordinatorContainer;
